// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"Intro_subtitle__AVU6W","description_wrapper":"Intro_description_wrapper__BM7x9"};